// src/components/menu/OperatorMenu.tsx

import {
  ExitToAppTwoTone,
  PersonTwoTone,
  SettingsTwoTone,
  WidthWideTwoTone,
} from '@mui/icons-material'
import { Avatar, IconButton, Menu, MenuItem } from '@mui/material'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import {
  OperatorData,
  useAppConfig,
  useOperator,
  useOperatorApi,
} from '../../hooks'

export const OperatorMenu = () => {
  const navigate = useNavigate()

  const { setAppConfig } = useAppConfig()

  const { logout } = useOperatorApi()

  const opData: OperatorData = useOperator()

  const [open, setOpen] = useState(null)

  const closeMenu = () => setOpen(null)

  const onGotoOperatorPage = () => {
    closeMenu()

    navigate('/user-page')
  }

  const onGotoSettingsPage = () => {
    closeMenu()

    setAppConfig(prev => ({ ...prev, showSettings: true }))
  }

  const onLogoutOperator = () => {
    closeMenu()
    logout()

    navigate('/pages/login-page')
  }

  const onOpen = event => {
    setOpen(event.currentTarget)
  }

  const onToggleWideScreen = () => {
    closeMenu()

    setAppConfig(prev => ({ ...prev, wideScreen: !prev.wideScreen }))
  }

  const src = opData?.image_url

  const operatorName = opData ? `${opData.first_name} ${opData.last_name}` : ''

  const data = [
    { fn: onGotoOperatorPage, icon: PersonTwoTone, title: operatorName },
    { fn: onGotoSettingsPage, icon: SettingsTwoTone, title: 'Einstellungen' },
    { fn: onToggleWideScreen, icon: WidthWideTwoTone, title: 'Wide Screen' },
    { fn: onLogoutOperator, icon: ExitToAppTwoTone, title: 'Abmelden' },
  ]

  return (
    <>
      <IconButton onClick={onOpen}>
        <Avatar src={src}>{!src && <PersonTwoTone />}</Avatar>
      </IconButton>

      <Menu anchorEl={open} open={Boolean(open)} onClose={closeMenu}>
        {data.map(item => (
          <MenuItem key={item.title} onClick={item.fn}>
            <item.icon sx={{ mr: 1 }} />
            {item.title}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
